"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishlistOrderChanged = void 0;
const wishlist_event_1 = require("./wishlist-event");
class WishlistOrderChanged extends wishlist_event_1.WishlistEvent {
    constructor(userId, targetStudyId, referenceStudyId, eventId, stateHash, dateChanged, isLocal) {
        super(dateChanged);
        this.userId = userId;
        this.targetStudyId = targetStudyId;
        this.referenceStudyId = referenceStudyId;
        this.eventId = eventId;
        this.stateHash = stateHash;
        this.dateChanged = dateChanged;
        this.isLocal = isLocal;
        this.eventType = WishlistOrderChanged.EventType;
        this.eventVersion = '1.0.0';
    }
    static create(userId, targetStudyId, referenceStudyId, stateHash, dateChanged = new Date(), isLocal) {
        return new WishlistOrderChanged(userId, targetStudyId, referenceStudyId, wishlist_event_1.WishlistEvent.generateId(), stateHash, dateChanged, isLocal);
    }
}
exports.WishlistOrderChanged = WishlistOrderChanged;
WishlistOrderChanged.EventType = 'WishlistOrderChanged';
